export function IconTimeOutSvg() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
      <g clipPath="url(#clip0_8118_34822)">
        <path
          d="M43.7427 25.5203C43.8473 21.7664 42.8223 18.0676 40.8004 14.903C38.7785 11.7384 35.8529 9.25385 32.4026 7.77121C28.9523 6.28857 25.1363 5.87617 21.4489 6.58741C17.7615 7.29865 14.3726 9.10077 11.7213 11.7603C9.06994 14.4199 7.27831 17.8143 6.57847 21.5039C5.87863 25.1935 6.30284 29.0082 7.79614 32.4539C9.28943 35.8996 11.783 38.8175 14.9538 40.8296C18.1247 42.8417 21.8267 43.8553 25.5802 43.7391"
          stroke="#E02424"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M33.332 39.584C33.332 41.2416 33.9905 42.8313 35.1626 44.0034C36.3347 45.1755 37.9244 45.834 39.582 45.834C41.2396 45.834 42.8293 45.1755 44.0014 44.0034C45.1736 42.8313 45.832 41.2416 45.832 39.584C45.832 37.9264 45.1736 36.3367 44.0014 35.1646C42.8293 33.9925 41.2396 33.334 39.582 33.334C37.9244 33.334 36.3347 33.9925 35.1626 35.1646C33.9905 36.3367 33.332 37.9264 33.332 39.584Z"
          stroke="#E02424"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M35.418 43.7493L43.7513 35.416"
          stroke="#E02424"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25 14.584V25.0007L29.1667 29.1673"
          stroke="#E02424"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_8118_34822">
          <rect width="50" height="50" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
